<template>
  <div>

    <div class="bg-white">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="flex align-center margin-right-sm">
            <span>调查结果：</span>
            <el-select v-model="status" placeholder="请选择">
              <el-option
                  v-for="item in resultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <el-button type="warning" @click="exportMinDiao">导出调查数据</el-button>
      </div>
      <el-table
          :data="merdekaList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
        </el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="楼门户" >
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="房屋面积(平米)" prop="mianji"></el-table-column>
        <el-table-column label="房屋性质">
          <template slot-scope="scope">
            <div>
              {{ scope.row.xingzhi | xingzhi }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="户主姓名" prop="huzu_name"></el-table-column>
        <el-table-column label="手机号" prop="huzu_phone"></el-table-column>
        <el-table-column label="居住情况">
          <template slot-scope="scope">
            <div>
              {{ scope.row.juzhu_qingkuang | juzhuQingkuang }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="调查结果">
          <template slot-scope="scope">
            <div>
              <el-select v-model="scope.row.status" placeholder="请选择" @change="setStatus(scope.$index)">
                <el-option
                    v-for="item in resultstatue"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
import {filesCN, housingNature, liveSituation, optionList, result} from "@/utils/utils";
import {duLiMinDiaoJieGuoList, minDiaoJieGuoUpdate} from "@/api/merdeka";
import {exportMinDiao} from "@/api/exportExcel";

export default {
  name: "merdeka-cent-result",
  data() {
    return {
      resultList: result,
      status:0,
      merdekaList: [],
      resultstatue: optionList(false,result),
    }
  },
  created() {
    this.$emit("setIndex", '/home/merdeka-center', "独立民调 / 民调结果", true);
    this.getResult()
  },
  components: {},
  methods: {
    //  民调结果导出
    async exportMinDiao(){
      let _state = await exportMinDiao(this.$route.params.id,this.status)
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '民调结果数据.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  修改状态
    async setStatus(index){
     let _state = await minDiaoJieGuoUpdate(this.merdekaList[index].id,this.merdekaList[index].status)
      this.$message.success(_state.info)
    },
    //  搜索
    hanldSearch(){
      this.getResult()
    },
    //  获取列表
    async getResult(){
      let _list = await duLiMinDiaoJieGuoList(this.$route.params.id,this.status)
      this.merdekaList = _list.data
    }
  },
  filters: {
    juzhuQingkuang(val){
      return filesCN(val,liveSituation)
    },
    xingzhi(val){
      return filesCN(val,housingNature)
    },
  },
  watch: {

  },
}
</script>

<style scoped lang="scss">

</style>